<template>
    <div>
        <!-- <audio ref="newOrderSound">
            <source src="../../assets/mp3/new_order.mp3" type="audio/mpeg">
        </audio> -->
        <CCard v-if="useFilter" class="p-1">
            <CRow>
                <CCol
                    cols="12"
                    col="6"
                    sm="6"
                    xl="3"
                    class="d-flex align-items-center custom-order-2 order-sm-2 order-xl-1 mb-sm-2 mb-xl-0">
                    <CSwitch
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="showFilters"
                        class="ml-2" />
                    <span class="ml-2">Фильтры</span>
                </CCol>
                <CCol
                    cols="12"
                    col="12"
                    sm="12"
                    xl="5"
                    class="custom-order-1 order-sm-1 order-xl-2 mb-3 mb-sm-0">
                    <CRow>
                        <CCol
                            v-if="useSorter"
                            cols="12"
                            col="6"
                            sm="8"
                            xl="10">
                            <CSelect
                                v-if="useSorter"
                                class="mb-xl-0 ml-sm-2"
                                placeholder="Сортировка..."
                                :value.sync="sorter"
                                :options="sorterOptions"
                                :change="setSorter()" />
                        </CCol>
                        <CCol
                            v-if="useSorter"
                            cols="12"
                            col="6"
                            sm="4"
                            xl="2"
                            class="text-right">
                            <CButton
                                v-if="useSorter"
                                class="mr-2"
                                color="secondary"
                                @click="resetSorter">Сбросить</CButton>
                        </CCol>
                    </CRow>
                </CCol>
                <CCol
                    cols="12"
                    col="6"
                    sm="6"
                    xl="4"
                    class="text-right custom-order-3 order-sm-3 order-xl-3 mb-sm-2 mb-xl-0">
                    <CButton
                        color="info"
                        class="mr-2"
                        @click="openSettingsModal">Выбрать колонки</CButton>
                </CCol>
            </CRow>
            <CRow v-if="showFilters" class="mt-1 mb-1">
                <CCol cols="12" md="4">
                    <multiselect
                        v-model="filter.status"
                        :options="filterOptions.statuses"
                        label="label"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Статус..."
                        track-by="value"
                        :change="$emit('set-filter', filter)" />
                </CCol>
                <CCol cols="12" md="4">
                    <multiselect
                        v-model="filter.type"
                        :options="filterOptions.types"
                        label="label"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Тип..."
                        track-by="value" />
                </CCol>
                <CCol cols="12" md="4">
                    <multiselect
                        v-model="filter.tower"
                        :options="filterOptions.towers"
                        label="label"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Башня..."
                        track-by="value" />
                </CCol>
            </CRow>
            <CRow v-if="showFilters" class="mb-1">
                <CCol cols="12" md="6">
                    <multiselect
                        v-model="filter.courier_id"
                        :options="filterOptions.couriers"
                        label="label"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Курьер..."
                        track-by="value" />
                </CCol>
                <CCol cols="12" md="6">
                    <multiselect
                        v-model="filter.concierge_id"
                        :options="filterOptions.concierges"
                        label="label"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Консьерж..."
                        track-by="value" />
                </CCol>
                <CCol
                    class="mt-1"
                    cols="12"
                    md="6">
                    <multiselect
                        v-model="filter.have_rating"
                        :options="filterOptions.have_rating"
                        label="label"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Оценка..."
                        track-by="value" />
                </CCol>
                <CCol
                    class="mt-1"
                    cols="12"
                    md="6">
                    <multiselect
                        v-model="filter.have_tips"
                        :options="filterOptions.have_tips"
                        label="label"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Чаевые..."
                        track-by="value" />
                </CCol>
                <CCol
                    class="mt-1"
                    cols="12"
                    md="12">
                    <multiselect
                        v-model="filter.have_comments"
                        :options="filterOptions.have_comments"
                        label="label"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Комментарии..."
                        track-by="value" />
                </CCol>
            </CRow>
            <CRow v-if="showFilters" class="mb-3 mt-3 pl-1">
                <CCol cols="12" md="2"> С: </CCol>
                <CCol cols="12" md="4">
                    <DatePicker
                        v-model="filter.from"
                        :language="datepicker.lang"
                        :format="datepicker.format"
                        input-class="custom-datepicker"
                        placeholder="Выберите дату..."
                    />
                </CCol>
                <CCol cols="12" md="2"> По: </CCol>
                <CCol cols="12" md="4">
                    <DatePicker
                        v-model="filter.to"
                        :language="datepicker.lang"
                        :format="datepicker.format"
                        :change="$emit('set-filter', filter)"
                        input-class="custom-datepicker"
                        placeholder="Выберите дату..."
                    />
                </CCol>
            </CRow>
            <CRow v-if="showFilters" class="mb-3 mt-3 pl-1">
                <CCol cols="12" md="2"> Клиент: </CCol>
                <CCol
                    cols="12"
                    md="3"
                    class="mt-1 mb-1">
                    <CInput
                        v-model="filter.client_last_name"
                        placeholder="Фамилия"
                        class="mb-0" />
                </CCol>
                <CCol
                    cols="12"
                    md="3"
                    class="mt-1 mb-1">
                    <CInput
                        v-model="filter.client_first_name"
                        placeholder="Имя"
                        class="mb-0" />
                </CCol>
                <CCol
                    cols="12"
                    md="3"
                    class="mt-1 mb-1">
                    <CInput
                        v-model="filter.client_phone"
                        placeholder="Телефон"
                        class="mb-0" />
                </CCol>
            </CRow>
            <CRow v-if="showFilters">
                <CCol cols="12" md="6">
                    <CButton
                        v-if="useFilter"
                        color="secondary"
                        @click="resetFilters">Сбросить</CButton>
                </CCol>
            </CRow>
        </CCard>
        <span class="ml-2">Всего: <strong>{{ total }}</strong></span>
        <!-- Add class 'custom-table' to make table adaptive for height -->
        <CDataTable
            :class="`orders ${useFilter ? '' : 'large'}`"
            :column-filter="useSearch"
            hover
            :items="list"
            :fields="fields"
        >
            <!-- ID -->
            <template #id-filter>
                <CInput
                    v-model="searchFilters.id"
                    class="mb-0 small__input"
                    type="text"
                />
            </template>
            <template #id="data">
                <td
                    :title="data.item.customer.firstOrder === data.item.id ? 'Первый заказ клиента.' : ''"
                    :style="getStatusColor(data.item.customer.status)"
                    :class="{ 'business-order-cell': isBusinessOrder(data.item) }">
                    <CLink :to="`/orders/${data.item.id}`">#{{ data.item.id }}</CLink>
                    <CBadge v-if="isBusinessOrder(data.item)" color="info" class="ml-1">B2B</CBadge>
                    <CBadge v-if="isShopOrder(data.item)" class="ml-1 shop-order-badge" title="Стол заказов">СЗ</CBadge>
                    <sup class="first__order"><b>{{ data.item.customer.firstOrder === data.item.id ? 1 : '' }}</b></sup>
                </td>
            </template>
            <!-- Приготовить до -->
            <template #preparation_time-filter>
                <CInput
                    v-model="searchFilters.preparation_time"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #preparation_time="data">
                <td
                    :class="{
                        'warning-cell': checkPreparationTimeRemaining(data.item)
                    }">
                    <div v-html="getPreparationTimeWithRemaining(data.item)"></div>
                </td>
            </template>
            <!-- Тип заказа -->
            <template #type-filter>
                <CInput
                    v-model="searchFilters.type"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #type="data">
                <td>{{ orderTypeTitle(data.item.type, data.item) }}</td>
            </template>
            <!-- Создан -->
            <template #created_at-filter>
                <CInput
                    v-model="searchFilters.created_at"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #created_at="data">
                <td>{{ getCreatedAt(data.item.created_at) }}</td>
            </template>
            <!-- Изменен -->
            <template #updated_at-filter>
                <CInput
                    v-model="searchFilters.updated_at"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #updated_at="data">
                <td>{{ getUpdatedAt(data.item.logs) }}</td>
            </template>
            <!-- Статус -->
            <template #status-filter>
                <CInput
                    v-model="searchFilters.status"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #status="data">
                <td class="status-cell">
                    <CBadge
                        :style="
                            orderStatusStyle(
                                data.item.status,
                                data.item.type,
                                data.item.payment_type
                            )
                        ">&nbsp;{{
                        orderStatusTitle(data.item)
                    }}&nbsp;</CBadge>
                </td>
            </template>
            <!-- Telegram отправка -->
            <template #tg_sended-filter>
                <CInput
                    v-model="searchFilters.tg_sended"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #tg_sended="data">
                <td
                    class="text-center bot-status-cell"
                    :title="getBotSendTitle(data.item.tg_sended, 'Telegram')">
                    <span :class="getBotSendClass(data.item.tg_sended)">
                        {{ getBotSendIcon(data.item.tg_sended) }}
                    </span>
                </td>
            </template>
            <!-- MAX отправка -->
            <template #max_sended-filter>
                <CInput
                    v-model="searchFilters.max_sended"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #max_sended="data">
                <td
                    class="text-center bot-status-cell"
                    :title="getBotSendTitle(data.item.max_sended, 'MAX')">
                    <span :class="getBotSendClass(data.item.max_sended)">
                        {{ getBotSendIcon(data.item.max_sended) }}
                    </span>
                </td>
            </template>
            <!-- Курьер -->
            <template #courier-filter>
                <CInput
                    v-model="searchFilters.courier"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #courier="data">
                <td>
                    <div v-if="data.item.courier">
                        <CLink :to="`/couriers/${data.item.courier.id}`">
                            {{ data.item.courier.name }}
                            <span
                                :class="{
                                    dot: true,
                                    seen: data.item.courier_approve
                                }"></span>
                        </CLink>
                    </div>
                    <div v-for="assignee in getCourierAssignees(data.item)" :key="assignee.user_id">
                        <CLink :to="`/couriers/${assignee.user_id}`">
                            {{ assignee.user_details.name }}
                        </CLink>
                    </div>
                    <span v-if="!data.item.courier && !getCourierAssignees(data.item).length">Нет</span>
                </td>
            </template>
            <!-- Консьерж -->
            <template #concierge-filter>
                <CInput
                    v-model="searchFilters.concierge"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #concierge="data">
                <td>
                    <div v-if="data.item.concierge">
                        <CLink :to="`/concierges/${data.item.concierge.id}`">
                            {{ data.item.concierge.name }}
                            <span
                                :class="{
                                    dot: true,
                                    seen: data.item.concierge_approve
                                }"></span>
                        </CLink>
                    </div>
                    <div v-for="assignee in getConciergeAssignees(data.item)" :key="assignee.user_id">
                        <CLink :to="`/concierges/${assignee.user_id}`">
                            {{ assignee.user_details.name }}
                        </CLink>
                    </div>
                    <span v-if="!data.item.concierge && !getConciergeAssignees(data.item).length">Нет</span>
                </td>
            </template>
            <!-- Доставить к -->
            <template #delivery_time-filter>
                <CInput
                    v-model="searchFilters.delivery_time"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #delivery_time="data">
                <td v-html="getDeliveryTime(data.item)"></td>
            </template>
            <!-- Стоимость доставки -->
            <template #delivery_price-filter>
                <CInput
                    v-model="searchFilters.delivery_price"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #delivery_price="data">
                <td>{{ data.item.delivery_price }}</td>
            </template>
            <!-- Сервисный сбор -->
            <template #service_fee-filter>
                <CInput
                    v-model="searchFilters.service_fee"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #service_fee="data">
                <td>{{ data.item.service_fee }}</td>
            </template>
            <!-- Осталось -->
            <template #time_remaining-filter>
                <CInput
                    v-model="searchFilters.time_remaining"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #time_remaining="data">
                <td
                    :class="{
                        'warning-cell': checkTimeRemaining(data.item)
                    }">{{ getTimeRemaining(data.item) }}</td>
            </template>
            <!-- Организации -->
            <template #companies-filter>
                <CInput
                    v-model="searchFilters.companies"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #companies="data">
                <td>
                    <ul>
                        <li v-for="link in getCompanies(data.item)" :key="link.title">
                            <CLink :to="link.link">{{ link.title }}</CLink><br />
                        </li>
                    </ul>
                </td>
            </template>
            <!-- Башня -->
            <template #tower-filter>
                <CInput
                    v-model="searchFilters.tower"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #tower="data">
                <td>{{ getTower(data.item) }}</td>
            </template>
            <!-- Адрес -->
            <template #delivery_address-filter>
                <CInput
                    v-model="searchFilters.delivery_address"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #delivery_address="data">
                <td :title="getDeliveryAddress(data.item)">
                    <span
                        :class="{
                            pass__info: true,
                            passed: data.item.pass === PASS_TYPE.PASSED,
                            not__need: data.item.pass === PASS_TYPE.NOT_NEED,
                            not__passed: data.item.pass === PASS_TYPE.NOT_PASSED,
                            without__delivery: data.item.delivery_type === DELIVERY_TYPE.WITHOUT
                        }"
                        :title="getPassTitle(data.item.pass)"></span>
                    {{ cutDeliveryAddress(getDeliveryAddress(data.item)) }}
                </td>
            </template>
            <!-- Клиент -->
            <template #customer-filter>
                <CInput
                    v-model="searchFilters.customer"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #customer="data">
                <td>
                    <CLink :to="`/customers/${data.item.customer.id}`">{{
                        getCustomer(data.item.customer)
                    }}</CLink>
                </td>
            </template>
            <!-- Комментарий -->
            <template #customer_comment-filter>
                <CInput
                    v-model="searchFilters.customer_comment"
                    class="mb-0 small__input"
                    type="text"
                />
            </template>
            <template #customer_comment="data">
                <td :title="data.item.customer_comment">{{ data.item.customer_comment ? cutComment(data.item.customer_comment) : "" }}</td>
            </template>
            <!-- Оценка -->
            <template #rating-filter>
                <CInput
                    v-model="searchFilters.review"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #rating="data">
                <td>{{ data.item.review ? data.item.review.rating : data.item.rating }}</td>
            </template>
            <!-- Чаевые -->
            <template #tips-filter>
                <CInput
                    v-model="searchFilters.tips"
                    class="mb-0 small__input"
                    type="text"
                    disabled
                />
            </template>
            <template #tips="data">
                <td>{{ data.item.tips ? data.item.tips : '' }}</td>
            </template>
            <!-- Цена -->
            <template #price-filter>
                <CInput
                    v-model="searchFilters.price"
                    class="mb-0 small__input"
                    type="text"
                />
            </template>
            <template #price="data">
                <td>{{ data.item.price }}</td>
            </template>
        </CDataTable>

        <CModal
            title="Настройки отображения"
            :show.sync="settingsModal"
            :footer="true"
            color="info">
            <template>
                <div slot="header">Настройки отображения</div>
                <div slot="body-wrapper" class="modal-body">
                    <CRow v-for="field in fieldsAll" :key="field.key">
                        <CCol
                            tag="label"
                            sm="6"
                            class="col-form-label">
                            {{ field.label }}
                        </CCol>
                        <CCol sm="6">
                            <CSwitch
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="fieldsSettings[field.key]" />
                        </CCol>
                    </CRow>
                </div>
                <div slot="footer">
                    <CButton color="primary" @click="closeSettingsModal">Сохранить</CButton>
                </div>
            </template>
        </CModal>

        <CModal
            :show.sync="soundsOnModal">
            <template>
                <div slot="header">Звуки заказов</div>
                <div slot="body-wrapper" class="modal-body">
                    У вас включены звуки оповещений при поступлении нового заказа.
                    Отключить звуки заказов можно через меню пользователя в верхнем правом углу экрана.
                </div>
                <div slot="footer">
                    <CButton color="primary" @click="soundsOnModal = false">Понятно</CButton>
                </div>
            </template>
        </CModal>

        <!-- <CModal
            :show.sync="newOrderModal">
            <template>
                <div slot="header">Новый заказ</div>
                <div slot="body-wrapper" class="modal-body">
                    Поступил новый заказ.
                </div>
                <div slot="footer">
                    <CButton color="primary" @click="$router.push(`/orders/${lastOrderId}`)">К заказу</CButton>
                    <CButton color="error" @click="newOrderModal = false">Закрыть</CButton>
                </div>
            </template>
        </CModal> -->
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapState } from 'vuex';
    import store from '@/store';
    import moment from 'moment';
    import _ from 'lodash';
    import countdown from 'countdown';
    import Multiselect from 'vue-multiselect';
    import DatePicker from 'vuejs-datepicker';
    import { ru } from 'vuejs-datepicker/dist/locale';
    require('moment-countdown');

    import { ORDER_STATUS, DELIVERY_TYPE, ORDER_TYPE, PASS_TYPE } from '../../utils/order';
    const {
        orderStatusTitle,
        orderStatusStyle,
        orderTypeTitle,
    } = require('../../utils/order-views');
    const {
        formatDateShort,
        formatTimeShort,
    } = require('../../utils/views');

    export default {
        components: {
            Multiselect,
            DatePicker
        },

        props: {
            list: {
                type: Array,
                default: () => [],
            },
            total: {
                type: Number,
                default: 0,
            },
            orderType: {
                type: String,
                default: 'all',
            },
            useFilter: {
                type: Boolean,
                default: false,
            },
            useSorter: {
                type: Boolean,
                default: false,
            },
            useSearch: {
                type: Boolean,
                default: false,
            },
            completed: {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                isAuthorized: false,
                fieldsAll: [
                    { key: 'id', label: 'ID', _classes: 'font-weight-bold' },
                    { key: 'preparation_time', label: 'Приготовить до', partner_only: true },
                    { key: 'type', label: 'Тип' },
                    { key: 'created_at', label: 'Создан' },
                    { key: 'updated_at', label: 'Обновлен' },
                    { key: 'status', label: 'Статус' },
                    { key: 'tg_sended', label: 'TG' },
                    { key: 'max_sended', label: 'MAX' },
                    { key: 'courier', label: 'Курьер', admin_only: true },
                    { key: 'concierge', label: 'Консьерж', admin_only: true },
                    { key: 'delivery_time', label: 'Доставка', admin_only: true },
                    { key: 'delivery_price', label: 'Стоимость доставки', admin_only: true },
                    { key: 'service_fee', label: 'Сервисный сбор', admin_only: true },
                    { key: 'time_remaining', label: 'Ост.', admin_only: true },
                    { key: 'companies', label: 'Организации' },
                    { key: 'tower', label: 'Башня', admin_only: true },
                    { key: 'delivery_address', label: 'Адрес', admin_only: true },
                    { key: 'customer_comment', label: 'Комментарий пользователя' },
                    { key: 'customer', label: 'Клиент', admin_only: true },
                    { key: 'rating', label: 'Оценка', completed: true },
                    { key: 'tips', label: 'Чаевые', completed: true },
                    { key: 'price', label: 'Цена' },
                ],
                // Fields
                fieldsSettings: {},
                settingsModal: false,
                // Sorter
                sorter: localStorage.getItem('orders-table-sorter') || '',
                sorterOptions: [
                    { value: '', label: 'Сортировка...' },
                    // { value: "id-asc", label: "ID: по возрастанию" },
                    // { value: "id-desc", label: "ID: по убыванию" },
                    { value: 'created_at-asc', label: 'Создан: по возрастанию' },
                    { value: 'created_at-desc', label: 'Создан: по убыванию' },
                    // { value: "updated_at-asc", label: "Обновлен: по возрастанию" },
                    // { value: "updated_at-desc", label: "Обновлен: по убыванию" },
                    { value: 'delivery_time-asc', label: 'Доставка: по возрастанию' },
                    { value: 'delivery_time-desc', label: 'Доставка: по убыванию' },
                    // { value: "price-asc", label: "Цена: по возрастанию" },
                    // { value: "price-desc", label: "Цена: по убыванию" },
                    { value: 'status-asc', label: 'Статус: по возрастанию' },
                    { value: 'status-desc', label: 'Статус: по убыванию' },
                ],
                // Filters
                showFilters: false,
                filter: {
                    status: null,
                    type: null,
                    tower: null,
                    courier_id: null,
                    concierge_id: null,
                    have_comments: null,
                    have_rating: null,
                    have_tips: null,
                    from: null,
                    to: null,
                    client_last_name: null,
                    client_first_name: null,
                    client_phone: null,
                },
                filterOptions: {
                    statuses: [],
                    types: [],
                    towers: [],
                    couriers: [],
                    concierges: [],
                    have_comments: [],
                    have_rating: [],
                    have_tips: [],
                    from: null,
                    to: null,
                },
                searchFilters: {
                    id: '',
                    preparation_time: '',
                    customer_comment: '',
                    customer: '',
                    price: '',
                    tg_sended: '',
                    max_sended: '',
                },
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    dateFrom: null,
                    dateTo: null,
                },
                PASS_TYPE,
                DELIVERY_TYPE,
                expanded: [],
                // lastOrderId: null,
                soundsOnModal: false,
                // newOrderModal: false
            };
        },

        computed: {
            ...mapState('settings', ['soundsOn', 'soundsPopupShown']),
            fields() {
                const result = [];
                for (const item of this.fieldsAll) {
                    if (!this.completed && item.completed) {
                        continue;
                    }
                    // Показывать только для партнеров или для всех (если нет ограничения)
                    const showForPartner = !this.adminOnly && item.partner_only;
                    const showForAdmin = this.adminOnly && !item.partner_only && !item.admin_only;
                    const showForBoth = !item.admin_only && !item.partner_only;
                    const showAdminOnly = this.adminOnly && item.admin_only;
                    
                    if (showForPartner || showForAdmin || showForBoth || showAdminOnly) {
                        if (item.key === 'type') {
                            if (this.orderType === 'all') {
                                if (this.fieldsSettings[item.key]) {
                                    result.push(item);
                                }
                            }
                        } else {
                            if (this.fieldsSettings[item.key]) {
                                result.push(item);
                            }
                        }
                    }
                }
                return result;
            },
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
        },

        watch: {
            searchFilters:{
                deep: true,
                handler() {
                    if (this.useSearch) {
                        const debounceFunc = _.debounce( () => {
                            const search = { ...this.searchFilters };
                            if (search) {
                                for (const key in search) {
                                    if (!search[key]) {
                                        delete search[key];
                                    }
                                }
                            }
                            if(search && search.customer && search.customer.length >= 3) {
                                this.$emit('set-search', search);
                            } else if (search.customer && search.customer.length < 3) {
                                search.customer = '';
                            } else {
                                this.$emit('set-search', search);
                            }
                        }, 1000)

                        debounceFunc();
                    }
                }
            },
            datepicker() {
                this.filter.from = this.datepicker.dateFrom;
                this.filter.to = this.datepicker.dateTo;
            },
            list:{
                deep: true,
                handler() {
                    // if(this.soundsOn && !this.completed && this.list && this.list[0]) {
                    //     if (this.lastOrderId && this.lastOrderId !== this.list[0].id) {
                    //         const audio = this.$refs.newOrderSound;
                    //         audio.play();
                    //         this.newOrderModal = true;
                    //     }
                    //     this.lastOrderId = this.list[0].id;
                    // }
                }
            },
        },

        async created() {
            this.fieldsSettings = this.getFildsSettings();
            this.filterOptions = await this.getFilterOptions();
        },
        mounted() {
            store.dispatch('settings/fetch');
            if(!this.soundsPopupShown) {
                this.soundsOnModal = this.soundsOn;
                store.commit('settings/SET_SOUNDS_POPUP', true);
            }
        },

        methods: {
            getStatusColor(status) {
                switch (status) {
                    case 1: // GOLD
                        return 'color: #FFD700';
                    case 2: // SILVER
                        return 'color: #C0C0C0';
                    default:
                        return 'color: #000000';
                }
            },
            isBusinessOrder(item) {
                return !!(item && item.payment_method === 'company_account');
            },
            isShopOrder(item) {
                return !!(item && item.code === 'shop');
            },
            orderTypeTitle(orderTypeId, item = {}) {
                if (orderTypeId === ORDER_TYPE.ASSISTANT_HELP) {
                    return 'ПМ';
                }
                if (orderTypeId === ORDER_TYPE.ENTITY_DELIVERY && item?.ed?.items) {
                    const { entity } = item.ed.items[0];
                    return entity.entityType.title.charAt(0);
                }
                return orderTypeTitle(orderTypeId).charAt(0);
            },
            getCreatedAt(created_at) {
                const ca = moment(created_at);
                if (ca.isSame(new Date(), 'day')) {
                    return formatTimeShort(ca.toDate());
                } else {
                    return formatDateShort(ca.toDate());
                }
            },
            getUpdatedAt(logs = []) {
                let ISOString = new Date().toISOString();

                if (logs?.length) {
                    ISOString = logs[logs.length - 1].created_at;
                }

                countdown.setLabels(
                    'мс|с|м|ч|д|н|мес|г|дек|век|мил',
                    'мс|с|м|ч|д|н|мес|г|дек|век|мил',
                    ' ',
                    ', '
                );
                const updatedAt = countdown(
                    new Date(ISOString),
                    new Date(),
                    countdown.DAYS | countdown.HOURS | countdown.MINUTES
                ).toString();
                return updatedAt ? updatedAt : 'сейчас';
            },
            getCustomer(customer) {
                let customerInfo = '';
                if (customer.phone) {
                    customerInfo += customer.phone;
                }
                if (customer.firstname) {
                    customerInfo += ' ' + customer.firstname;
                }
                if (customer.lastname) {
                    customerInfo += ' ' + customer.lastname;
                }
                return customerInfo;
            },
            orderStatusTitle(order) {
                if (order.ed?.items?.length) {
                    return orderStatusTitle(
                        order.status,
                        order.type,
                        order.payment_type,
                        order.ed?.items[0]?.entity?.statuses,
                        order.delivery_type,
                        order.delivered_door,
                    );
                }
                return orderStatusTitle(
                    order.status,
                    order.type,
                    order.payment_type,
                    null,
                    order.delivery_type,
                    order.delivered_door,
                );
            },
            orderStatusStyle(orderStatusId, orderType, paymentType) {
                return orderStatusStyle(orderStatusId, orderType, paymentType);
            },
            getDeliveryAddress(item) {
                let address = '';
                if (!item.towerObj && item.address) {
                    address =
                        item.address.street + ' ' + item.address.building + ', ';
                }
                if (item.delivery_type === DELIVERY_TYPE.MEETING_POINT) {
                    address = 'точка встречи';
                } else if (item.delivery_type === DELIVERY_TYPE.WITHOUT) {
                    address = 'без доставки';
                } else if (item.address_details) {
                    address +=
                        'вх. ' +
                        item.address_details.entrance +
                        ', эт. ' +
                        item.address_details.floor +
                        ', оф. ' +
                        item.address_details.appartment;
                }
                return address;
            },
            getTower(item) {
                if (item.delivery_type === DELIVERY_TYPE.WITHOUT) {
                    return '';
                }
                return item.towerObj
                    ? item.towerObj.short_name
                        ? item.towerObj.short_name
                        : item.towerObj.name
                    : '';
            },
            getCompanies(item) {
                const result = {};
                if (item && item.rd && item.rd.items) {
                    for (const orderItem of item.rd.items) {
                        if (orderItem.restaurant && orderItem.restaurant.id) {
                            result[orderItem.restaurant.id] = {
                                link: '/restaurants/' + orderItem.restaurant.id,
                                title:
                                    (orderItem.restaurant.short_title
                                        ? orderItem.restaurant.short_title
                                        : orderItem.restaurant.title) +
                                    (orderItem.restaurant?.towerObj?.short_name
                                    ? ` (${orderItem.restaurant.towerObj?.short_name})`
                                    : ''),
                            };
                        }
                    }
                } else if (item && item.ed && item.ed.items) {
                    for (const orderItem of item.ed.items) {
                        if (orderItem.entity && orderItem.entity.id) {
                            result[orderItem.entity.id] = {
                                link: `entities/${orderItem.entity.entityType.code}/${orderItem.entity.id}`,
                                title:
                                    (orderItem.entity.short_name
                                        ? orderItem.entity.short_name
                                        : orderItem.entity.title) +
                                    (orderItem.entity?.towerObj?.short_name
                                    ? ` (${orderItem.entity.towerObj?.short_name})`
                                    : ''),
                            };
                        }
                    }
                } else if (item && item.fd && item.fd.items) {
                    for (const orderItem of item.fd.items) {
                        if (orderItem.florist && orderItem.florist.id) {
                            result[orderItem.florist.id] = {
                                link: '/florists/' + orderItem.florist.id,
                                title: orderItem.florist.short_title
                                    ? orderItem.florist.short_title
                                    : orderItem.florist.title,
                            };
                        }
                    }
                } else if (item && item.gd && item.gd.items) {
                    for (const orderItem of item.gd.items) {
                        if (orderItem.grocer && orderItem.grocer.id) {
                            result[orderItem.grocer.id] = {
                                link: '/grocers/' + orderItem.grocer.id,
                                title: orderItem.grocer.short_title
                                    ? orderItem.grocer.short_title
                                    : orderItem.grocer.title,
                            };
                        }
                    }
                } else if (item && item.ld && item.ld.items) {
                    for (const orderItem of item.ld.items) {
                        if (orderItem.laundry && orderItem.laundry.id) {
                            result[orderItem.laundry.id] = {
                                link: '/laundries/' + orderItem.laundry.id,
                                title: orderItem.laundry.short_title
                                    ? orderItem.laundry.short_title
                                    : orderItem.laundry.title,
                            };
                        }
                    }
                } else if (item && item.pd && item.pd.items) {
                    for (const orderItem of item.pd.items) {
                        if (orderItem.pharmacy && orderItem.pharmacy.id) {
                            result[orderItem.pharmacy.id] = {
                                link: '/pharmacies/' + orderItem.pharmacy.id,
                                title: orderItem.pharmacy.short_title
                                    ? orderItem.pharmacy.short_title
                                    : orderItem.pharmacy.title,
                            };
                        }
                    }
                } else if (item && item.ah && item.ah.items) {
                    for (const orderItem of item.ah.items) {
                        if (orderItem.assistant && orderItem.assistant.id) {
                            result[orderItem.assistant.id] = {
                                link: '/assistants/' + orderItem.assistant.id,
                                title: orderItem.assistant.short_title
                                    ? orderItem.assistant.short_title
                                    : orderItem.assistant.title,
                            };
                        }
                    }
                }
                return result;
            },
            getPassTitle(pass) {
                switch (pass) {
                case PASS_TYPE.PASSED: return 'Пропуск оформлен';
                case PASS_TYPE.NOT_PASSED: return 'Пропуск не оформлен';
                case PASS_TYPE.NOT_NEED: return 'Пропуск не требуется';
                default: return '';
                }
            },
            // getDeliveryTime(item) {
            //     if (item.delivery_time) {
            //         const deliveryTime = moment(item.delivery_time).locale('ru');

            //         if (item.delivery_now) {
            //             return `до ${deliveryTime.format('HH:mm')} <span style="font-size: 9px">${deliveryTime.format('DD MMM')}</span>`;
            //         } else {
            //             return `<strong>к ${deliveryTime.format('HH:mm')}</strong> <strong>${deliveryTime.format('DD MMM')}</strong>`;
            //         }
            //     }
            //     return '';
            // },
            getDeliveryTime(item) {
                if (item.delivery_time) {
                    const deliveryTime = moment(item.delivery_time).format('HH:mm DD.MM');
                    if (item.delivery_now) {
                        return `до ${deliveryTime}`;
                    } else {
                        return `<strong>к ${deliveryTime}</strong>`;
                    }
                }
                return '';
            },
            getTimeRemaining(item) {
                var dt = item.delivery_time;
                if (dt) {
                    dt = new moment(dt);
                    let theDate = new Date();

                    let lastStatusUpdate = item.updated_at;
                    if (item.logs && item.logs.length) {
                        const sortedLogs = [...item.logs].sort((a, b) => moment(b.created_at).diff(moment(a.created_at)));
                        lastStatusUpdate = sortedLogs[0].created_at;
                    }

                    if (
                        item.status === ORDER_STATUS.DONE ||
                        item.status === ORDER_STATUS.CANCELED
                    ) {
                        theDate = moment(lastStatusUpdate).toDate();
                        return (
                            (moment(theDate).diff(dt) > 0 ? '- ' : '') +
                            countdown(
                                theDate,
                                new Date(dt.toDate()),
                                countdown.DAYS | countdown.HOURS | countdown.MINUTES
                            )
                        );
                    }
                    return (
                        (moment().diff(dt) > 0 ? '- ' : '') +
                        countdown(
                            theDate,
                            new Date(dt.toDate()),
                            countdown.DAYS | countdown.HOURS | countdown.MINUTES
                        )
                    );
                }
                return '';
            },
            getPreparationTimeWithRemaining(item) {
                if (!item.delivery_time) {
                    return '<small>Не определено</small>';
                }

                // Вычисляем время приготовления (delivery_time - 15 минут)
                const preparationTime = moment(item.delivery_time).subtract(15, 'minutes');
                const now = moment();
                
                // Форматируем время приготовления
                const timeLabel = item.delivery_now ? 'до' : 'к';
                const timeFormat = item.delivery_now ? 'HH:mm' : 'HH:mm DD.MM';
                const formattedTime = `${timeLabel} ${preparationTime.format(timeFormat)}`;
                
                // Вычисляем оставшееся время
                const remaining = countdown(
                    now.toDate(),
                    preparationTime.toDate(),
                    countdown.HOURS | countdown.MINUTES
                );
                
                const isOverdue = now.isAfter(preparationTime);
                const remainingText = isOverdue ? `- ${remaining}` : remaining;
                
                return `${formattedTime}<br><small>(${remainingText})</small>`;
            },
            checkPreparationTimeRemaining(item) {
                if (!item.delivery_time) {
                    return false;
                }

                const doneStatuses = [ORDER_STATUS.DONE, ORDER_STATUS.CANCELED];
                if (doneStatuses.includes(item.status)) {
                    return false;
                }

                // Вычисляем время приготовления (delivery_time - 15 минут)
                const preparationTime = moment(item.delivery_time).subtract(15, 'minutes');
                const now = moment();

                // Подсвечиваем красным если время вышло или осталось меньше 10 минут
                if (now.isAfter(preparationTime)) {
                    return true;
                }

                const inTenMinutes = moment().add(10, 'minutes');
                return inTenMinutes.isSameOrAfter(preparationTime);
            },
            checkTimeRemaining(item) {
                const doneStatuses = [ORDER_STATUS.DONE, ORDER_STATUS.CANCELED];
                if (doneStatuses.includes(item.status)) {
                    return false;
                }

                const dt = item.delivery_time;
                if (dt) {
                    if (moment().isSameOrAfter(moment(dt))) {
                        return true;
                    }

                    const awaiting = (item.status === ORDER_STATUS.AWAITING) || (item.status === ORDER_STATUS.AWAITING_READY);
                    const delivering = (item.status === ORDER_STATUS.DELIVERY) || (item.status === ORDER_STATUS.DELIVERY_CONCIERGE);
                    const inTwentyMinutes = moment().add(20, 'minutes');
                    const inTenMinutes = moment().add(10, 'minutes');

                    const checkAwaiting = inTwentyMinutes.isSameOrAfter(moment(dt)) && awaiting;
                    const checkDelivering = inTenMinutes.isSameOrAfter(moment(dt)) && delivering;

                    return checkAwaiting || checkDelivering;
                }
                return false;
            },
            // Fields settings
            getFildsSettings() {
                var fieldsSettings = JSON.parse(
                    localStorage.getItem('orders-table-settings')
                );
                if (!fieldsSettings) {
                    fieldsSettings = this.getDefaultFieldsSettings();
                }
                return fieldsSettings;
            },
            getDefaultFieldsSettings() {
                const result = {};
                for (const item of this.fieldsAll) {
                    result[item.key] = true;
                }
                return result;
            },
            setFieldsSettings(fieldsSettings) {
                localStorage.setItem(
                    'orders-table-settings',
                    JSON.stringify(fieldsSettings)
                );
            },
            openSettingsModal() {
                this.settingsModal = true;
            },
            closeSettingsModal() {
                this.setFieldsSettings(this.fieldsSettings);
                this.settingsModal = false;
                this.$forceUpdate();
            },
            resetSorter() {
                this.sorter = '';
                localStorage.setItem(
                    'orders-table-sorter',
                    this.sorter
                );
            },
            setSorter() {
                localStorage.setItem(
                    'orders-table-sorter',
                    this.sorter
                );
                this.$emit('set-sorter', this.sorter);
            },
            // Filters
            async getFilterOptions() {
                const types = await this.getTypes();
                return {
                    types,
                    statuses: this.getStatuses(),
                    towers: await this.getTowers(),
                    couriers: await this.getCouriers(),
                    concierges: await this.getConcierges(),
                    have_comments: this.getComments(),
                    have_rating: this.getRating(),
                    have_tips: this.getTips(),
                    from: this,
                    to: null,
                };
            },
            getStatuses() {
                const options = [];
                options.push({ value: '', label: 'Выберите...' });
                for (const status in ORDER_STATUS) {
                    options.push({
                        value: ORDER_STATUS[status],
                        label: orderStatusTitle(ORDER_STATUS[status]),
                    });
                }
                if (this.completed) {
                    options.splice(1, 8);
                }
                return options;
            },
            async getTypes() {
                const options = [];
                options.push({ value: '', label: 'Выберите...' });
                for (const type in ORDER_TYPE) {
                    options.push({
                        value: ORDER_TYPE[type],
                        label: orderTypeTitle(ORDER_TYPE[type]),
                    });
                }
                const entities = await Vue.axios.get('/entities-type/');
                entities.data.forEach(entity => {
                    const condidate = options.findIndex(filter => filter.value === entity.code);
                    if (condidate === -1) {
                        options.push({
                            value: entity.code,
                            label: entity.title,
                        })
                    } else {
                        options.splice(condidate, 1, {
                            value: entity.code,
                            label: entity.title,
                        });
                    }
                })
                return options.filter(filter => filter.value !== ORDER_TYPE.ENTITY_DELIVERY);
            },
            async getTowers() {
                const options = [];
                options.push({ value: '', label: 'Выберите...' });
                const result = await Vue.axios.get('/address');
                result.data.forEach(item => {
                    options.push({ value: item.id, label: item.name });
                });
                return options;
            },
            async getCouriers() {
                const options = [];
                options.push({ value: '', label: 'Выберите...' });
                const result = await Vue.axios.get('/couriers?pageSize=100');
                result.data.results.forEach(item => {
                    options.push({ value: item.id, label: item.name });
                });
                return options;
            },
            async getConcierges() {
                const options = [];
                options.push({ value: '', label: 'Выберите...' });
                const result = await Vue.axios.get('/concierges?pageSize=100');
                result.data.results.forEach(item => {
                    options.push({ value: item.id, label: item.name });
                });
                return options;
            },
            getComments() {
                const options = [];
                options.push({ value: 'all', label: 'Все...' });
                options.push({ value: true, label: 'С комментариями...' });
                options.push({ value: false, label: 'Без комментариев...' });
                return options;
            },
            getRating() {
                const options = [];
                options.push({ value: 'all', label: 'Все...' });
                options.push({ value: true, label: 'С оценкой...' });
                options.push({ value: false, label: 'Без оценки...' });
                return options;
            },
            getTips() {
                const options = [];
                options.push({ value: 'all', label: 'Все...' });
                options.push({ value: true, label: 'С чаевыми...' });
                options.push({ value: false, label: 'Без чаевых...' });
                return options;
            },
            resetFilters() {
                this.filter = {
                    status: null,
                    type: null,
                    tower: null,
                    courier_id: null,
                    concierge_id: null,
                    have_comments: null,
                    have_rating: null,
                    have_tips: null,
                    from: null,
                    to: null,
                    client_last_name: null,
                    client_first_name: null,
                    client_phone: null,
                };
            },
            cutComment(customer_comment) {
                return `${customer_comment.slice(0, 15)}...`;
            },
            cutDeliveryAddress(address) {
                return `${address.slice(0, 15)}...`;
            },
            getCourierAssignees(item) {
                if (!Array.isArray(item.additional_assignees)) return [];
                return item.additional_assignees.filter(a => a.type === 'courier' && a.user_details);
            },
            getConciergeAssignees(item) {
                if (!Array.isArray(item.additional_assignees)) return [];
                return item.additional_assignees.filter(a => a.type === 'concierge' && a.user_details);
            },
            getBotSendIcon(value) {
                return value ? '✓' : '✗';
            },
            getBotSendClass(value) {
                return value ? 'bot-status-success' : 'bot-status-failed';
            },
            getBotSendTitle(value, channelName) {
                return value
                    ? `Отправлено в ${channelName}`
                    : `Не отправлено в ${channelName}`;
            },
        },
    };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.custom-table .position-relative.table-responsive {
    max-height: calc(100vh - 407px);
}
.custom-table.large .position-relative.table-responsive {
    max-height: calc(100vh - 337px);
}

.custom-table table thead th {
    position: sticky;
    box-shadow: 0 0 0 rgba( 0, 0, 0, .3);
    top: -1px;
    background: #fff;
}
.orders .small__input input {
    padding: 0;
}
input.custom-datepicker {
  border: 1px solid;
  border-color: #d8dbe0;
  width: 100%;
}

.orders table thead th {
    padding: 2px 4px;
    font-size: 11px;
}
</style>

<style scoped>
.dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    vertical-align: middle;

    vertical-align: middle;

    background: red;

    border-radius: 50%;
}
.dot.seen {
    background: #23d923;
}
.warning-cell {
    background: red;
    border-radius: 10px;

    color: #fff;
    font-weight: bold !important;
}
.business-order-cell {
    background: #e8f4ff;
}
.shop-order-badge {
    background-color: #6f42c1;
    color: #fff;
}
.status-cell span {
    display: block;
}
.bot-status-cell {
    font-size: 16px;
}
.bot-status-success {
    color: #2eb85c;
    font-weight: 700;
}
.bot-status-failed {
    color: #e55353;
    font-weight: 700;
}
.orders table td,
.orders table th {
    white-space: nowrap;
    padding: 0.1rem;
}

@media (max-width: 576px) {
    .custom-order-1 {
        order: 1;
    }
    .custom-order-2 {
        order: 2;
    }
    .custom-order-3 {
        order: 3;
    }
}
.pass__info {
    display: inline-block;
    width: 20px;
    height: 12px;

    border: 2px solid;
    border-radius: 3px;
}
.not__passed {
    background: red;
    border-color: red;
}
.passed {
    background: #68CE85;
    border-color: #68CE85;
}
.not__need {
    background: transparent;
    border-color: #68CE85;
}
.without__delivery {
    background: transparent;
    border-color: #ff7b49;
}
.first__order {
    font-size: 12px;
    color: #2eb85c;
}
</style>
